// **************************************************
// Share
// **************************************************

const shareIcon = document.querySelectorAll('.mod-share__icon');

shareIcon.forEach((elm) => {
  elm.addEventListener('click', (ev) => {
    const shareParent = ev.target.closest('.mod-share');
    shareParent.classList.toggle('is-active');
  });
});
